import React, { Component } from "react";
import styled from "styled-components";

import { pxUrl } from "@/database/homePage/services";

const Div = styled.div`
  height: 6.4rem;
  background-color: #1677ff;
  display: flex;
  flex-direction: column;
  align-items: center;

  ul {
    width: 120rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      position: relative;
      height: 100%;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.6rem;
      cursor: pointer;
      &:hover {
        font-weight: bold;
        &::after {
          position: absolute;
          content: "";
          width: 2.5rem;
          height: 0.2rem;
          background-color: #ffffff;
          bottom: 1.4rem;
          left: 2rem;
        }
      }
    }
  }
`;

class NavBar extends Component {
  state = {
    navDatas: [
      "网站首页",
      "学习报名",
      "在线练习",
      "考题练习",
      "模拟考试",
      "培训学习",
      // "学校官网",
    ],
  };

  handleNavClick = (name) => {
    switch (name) {
      case "网站首页":
        this.props.history.push("/");
        break;
      case "学习报名":
        this.props.history.push("/signup");
        break;
      case "在线练习":
        window.open(pxUrl);
        break;
      case "考题练习":
        window.open(pxUrl);
        break;
      case "模拟考试":
        window.open(pxUrl);
        break;
      case "培训学习":
        window.open(pxUrl);
        break;
        // case "学校官网":
        // window.open("http://www.shunzepeixun.com");
        // break;
    }
  };

  render() {
    const { navDatas } = this.state;

    return (
      <Div>
        <ul>
          {navDatas.map((name, index) => (
            <li key={index}>
              <div
                onClick={() => {
                  this.handleNavClick(name);
                }}
              >
                {name}
              </div>
            </li>
          ))}
        </ul>
      </Div>
    );
  }
}

export default NavBar;
